import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  name: string;
  risk_level?: "low" | "medium" | "high";
}
export const useEditEntityType = () => {
  const { authHeader } = useAuth();

  return useMutation(({ params, id }: { params: Params; id: number }) => {
    return axios.put(
      `${env.verifyServiceUrl}individual/entity_type/${id}/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
